import { Component, OnInit, ViewChild } from '@angular/core';
import { LicencasService } from 'src/app/shared/api/licencas/licencas.service';
import { Router } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PaginatedResponse } from 'src/app/shared/api/pagination.model';
import { filtroPessoalLicencasResource } from './filtro-pessoal-licencas.resource';
import { TestesService } from 'src/app/shared/api/testes/testes-cliente.service';
import { ITeste } from 'src/app/shared/api/testes/testes.service';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { AuthService } from 'src/app/shared/services/auth.service';
import { TipoTeste, TipoTesteLabels } from 'src/app/shared/model/tipo-teste.enum';

@Component({
    selector: 'app-pessoal-licencas',
    templateUrl: './pessoal-licencas.component.html',
    styleUrls: ['./pessoal-licencas.component.scss']
})
export class PessoalLicencasComponent implements OnInit {
    // @ViewChild('cardContent') cardContent!: HTMLDivElement;

    // cardOpened = false;
    // filtroPessoalLicencasResource = filtroPessoalLicencasResource;

    tiposTeste = Object.values(TipoTeste);

    constructor(        
        private authService: AuthService
    ) { }

    ngOnInit(): void {
        this.authService.setTheme('dark');
    }

    // changeFiltro(event: any) {
    //     const filtro: any = {
    //         pagina: this.filtro.pagina || 1,
    //         tamanho: this.filtro.tamanho || 12
    //     };

    //     if (this.filtro.concluido && this.filtro.concluido != 3)
    //         filtro['concluido'] = this.filtro.concluido.id;
    //     if (this.filtro.teste) filtro['teste'] = this.filtro.teste;

    //     this.listarTestes(filtro);
    // }

}
